// @module Eureka.MaxaPartPicker.MaxaPartPicker
define('Eureka.MaxaPartPicker.MaxaPartPickerMain.View'
    , [
        'PageType.Base.View',

        'MaxaPartPicker.Collection',
        'MaxaPartPicker.Collection.View',
        'eureka_maxapartpicker_maxapartpickermain.tpl',
        'facets_items_collection_view_cell.tpl',
        'facets_items_collection_view_row.tpl',
        'Backbone.CollectionView',
        'MaxaPartPicker.Details.View',
        'eureka_maxapartpicker_collection.tpl',
        'jQuery',
        'Configuration',
        'underscore',
        'PartPickerPagination',
        'PartPickerSort'

    ]
    , function (
        PageTypeBaseView,
        MaxaPartPickerCollection,
        MaxaPartPickerCollectionView,
        eureka_maxapartpicker_maxapartpickermain_tpl,
        facets_items_collection_view_cell_tpl,
        facets_items_collection_view_row_tpl,
        BackboneCollectionView,
        FacetsItemCellView,
        facets_items_collection_tpl,
        jQuery,
        Configuration,
        _,
        PartPickerPagination,
        PartPickerSort
    ) {
        'use strict';

        // @class Eureka.MaxaPartPicker.MaxaPartPicker.View @extends Backbone.View
        return PageTypeBaseView.PageTypeBaseView.extend({

            template: eureka_maxapartpicker_maxapartpickermain_tpl

            , initialize: function () {
                var self = this;
                this.collection = new MaxaPartPickerCollection();
                if (!self.facets) {
                    self.facets = []
                }
                // Listen to changes in the collection and update facets/model details accordingly
                this.collection.on('reset sync add remove change destroy', function () {
                    if (self.collection.length > 0) {
                        for (var i = 0; i < self.collection.length; i++) {
                            // If the model attributes exist, set relevant details for model, brand, type, and facets
                            if (!self.model) {
                                self.model = self.collection.models[i].attributes.imageModel.model
                                self.brand = self.collection.models[i].attributes.imageModel.brand
                                self.type = self.collection.models[i].attributes.imageModel.type
                                self.image = self.collection.models[i].attributes.imageModel.image
                                self.facets = self.collection.models[i].attributes.imageModel.areas
                                if (self.facets) {
                                    // Update facet URLs for filtering
                                    for (var j = 0; j < self.facets.length; j++) {
                                        self.facets[j].url = window.location + '&area=' + self.facets[j].id
                                    }
                                }
                            }
                        }
                    }
                });
                // Callback to handle navigation events and update the state based on URL changes
                const myCallback = () => {
                    document.body.style.cursor = 'wait';
                    var originalHas = window.location.hash.substr(1);
                    var originalHasSplit = originalHas.split('&').reduce(function (res, item) {
                        var parts = item.split('=');
                        res[parts[0]] = parts[1];
                        return res;
                    }, {});
                    //console.log("Options", this.options)
                    var url = event.destination.url
                    var lastPart = url.substr(url.lastIndexOf('/') + 1);
                    // If the last part of the URL is "partspicker", then push the history so the back button works
                    if (lastPart === "partspicker") {
                        history.pushState({}, '', self.url);
                    } else {
                        //If this fires then we have navigated off the parts picker page
                        if (window.location.href.indexOf('partspicker') > -1) {
                            document.body.style.cursor = 'default'
                            self.url = window.location.href;
                        }
                    }
                    var hash = event.destination.url.split('#')[1]
                    // If there is a hash in the URL, parse it and update the collection and facets
                    if (hash) {
                        var hashSplit = hash.split('&').reduce(function (res, item) {
                            var parts = item.split('=');
                            res[parts[0]] = parts[1];
                            return res;
                        }, {});
                        // Determine if the hashSplit represents a significant change
                        let changed = (originalHasSplit.typeid !== hashSplit.typeid) || (originalHasSplit.brands !== hashSplit.brands) || (originalHasSplit.models !== hashSplit.models);
                        if ((originalHasSplit.area === hashSplit.area) && !hashSplit.page && (originalHasSplit.sortby === hashSplit.sortby) && (originalHasSplit.instock === hashSplit.instock)) {
                            hashSplit.area = ""
                        }
                        // hashSplit = {models:204, typeid:111, brands: 30}
                        // Added this in because the area is removing the sorts
                        if (hashSplit.area) {
                            if (hashSplit.area !== originalHasSplit.area) {
                                if (originalHasSplit.instock) {
                                    hashSplit.instock = originalHasSplit.instock
                                }
                                if (originalHasSplit.sortby) {
                                    hashSplit.sortby = originalHasSplit.sortby
                                }
                            }
                        }
                        hashSplit.getimage = changed
                        if (hashSplit.models) {
                            self.collection.fetch({
                                data: hashSplit
                            }).done(function (result) {
                                if (hashSplit.area) {
                                    //console.log("hashSplit.area", hashSplit.area);
                                    for (var i = 0; i < self.facets.length; i++) {
                                        //console.log("self.facets[i]", self.facets[i]);
                                        self.facets[i].selected = self.facets[i].id === hashSplit.area;
                                        if (self.facets[i].id === hashSplit.area) {
                                            self.startPosition = i
                                        }
                                    }

                                    if (hashSplit.area !== originalHasSplit.area) {
                                        if (originalHasSplit.sortby || originalHasSplit.instock) {
                                            var url = window.location.href;
                                            url = url.split('#')[0]
                                            url += "#typeid=" + hashSplit.typeid + "&brands=" + hashSplit.brands + "&models=" + hashSplit.models + "&area=" + hashSplit.area
                                            if (originalHasSplit.sortby) {
                                                url += "&sortby=" + originalHasSplit.sortby
                                            }
                                            if (originalHasSplit.instock) {
                                                url += "&instock=" + originalHasSplit.instock
                                            }
                                            history.pushState(hashSplit, "", url)
                                            self.hasPushed = true
                                        }
                                    } else {
                                        self.hasPushed = false
                                    }

                                } else {
                                    for (var i = 0; i < self.facets.length; i++) {
                                        self.facets[i].selected = false
                                    }
                                    if (!self.hasPushed) {
                                        var url = window.location.href;
                                        url = url.split('#')[0]
                                        url += "#typeid=" + hashSplit.typeid + "&brands=" + hashSplit.brands + "&models=" + hashSplit.models
                                        if (hashSplit.page) {
                                            url += "&page=" + hashSplit.page
                                        }
                                        if (hashSplit.sortby) {
                                            url += "&sortby=" + hashSplit.sortby
                                        }
                                        if (hashSplit.instock) {
                                            url += "&instock=" + hashSplit.instock
                                        }
                                        history.pushState(hashSplit, "", url)
                                        self.hasPushed = true
                                    }
                                }
                                let values = (result[0]) ? result[0] : result;
                                if (changed) {
                                    self.model = values.imageModel.model
                                    self.brand = values.imageModel.brand
                                    self.type = values.imageModel.type
                                    self.image = values.imageModel.image
                                    self.facets = values.imageModel.areas
                                    if (self.facets) {
                                        for (var j = 0; j < self.facets.length; j++) {
                                            self.facets[j].url = window.location + '&area=' + self.facets[j].id
                                        }
                                    }

                                }
                                document.body.style.cursor = 'default'
                                self.render();
                            })
                        } else {
                            window.navigation.removeEventListener("navigate", myCallback)
                        }
                    }
                }

                window.navigation.addEventListener("navigate", myCallback)

                jQuery(document).ready(function () {
                    //console.log("Document Ready")
                    let readyDocument = setInterval(function () {
                        try {
                            if (!document.getElementById('type-breacrumb')) {
                                var nameObject = [self.type, self.brand, self.model];
                                if (self.type) {
                                    self.setBreadCrumbs(nameObject)
                                    clearInterval(readyDocument);
                                }
                            }
                        }catch(e){}
                    }, 1000)

                })
            },

            setBreadCrumbs: function setBreadCrumbs(nameObject) {
                var thisInterval = setInterval(function () {
                    var toplevel = document.getElementsByClassName('global-views-breadcrumb')[0]
                    var count = 0
                    if (toplevel) {
                        nameObject.forEach(function (name) {
                            var liBreak = document.createElement('li');
                            liBreak.appendChild(document.createTextNode(" > "))
                            liBreak.classList.add('global-views-breadcrumb-item');
                            toplevel.appendChild(liBreak);
                            var liType = document.createElement('li');
                            if (count === 0) {
                                liType.id = "type-breacrumb"
                                count++
                            }
                            liType.appendChild(document.createTextNode(name))
                            liType.classList.add('global-views-breadcrumb-item');
                            toplevel.appendChild(liType);
                        })
                        clearInterval(thisInterval)
                    }
                }, 1000)


            },

            beforeShowContent: function beforeShowContent() {
                var hash = window.location.hash.substr(1);
                var hashSplit = hash.split('&').reduce(function (res, item) {
                    var parts = item.split('=');
                    res[parts[0]] = parts[1];
                    return res;
                }, {});
                const pageAccessedByReload = (
                    (window.performance.navigation && window.performance.navigation.type === 1) ||
                    window.performance
                        .getEntriesByType('navigation')
                        .map((nav) => nav.type)
                        .includes('reload')
                );

                //console.log("pageAccessedByReload",pageAccessedByReload);

                // hashSplit = {models:204, typeid:111, brands: 30}

                hashSplit.getimage = true
                this.childViews = {
                    'MaxaPartPicker.Collection.View': function () {
                        return new BackboneCollectionView({
                            childTemplate: facets_items_collection_view_cell_tpl
                            , childView: FacetsItemCellView
                            , childViewOptions: {
                                application: this.application
                            }
                            , viewsPerRow: 24
                            , collection: this.collection
                            , cellTemplate: facets_items_collection_view_cell_tpl
                            , rowTemplate: facets_items_collection_view_row_tpl
                            , template: facets_items_collection_tpl
                        });
                    },
                    'PartPickerPagination': function () {
                        return new PartPickerPagination({
                            pages: 3
                        })
                    },
                    'PartPickerSort': function () {
                        return new PartPickerSort({
                            pages: 3
                        })
                    }
                }
                // if(sessionStorage.getItem('area')) {
                //     hashSplit = {models: 1, typeid: 1, brands: 1, area: 1}
                // }
                return this.collection.fetch({
                    data: hashSplit
                })
            },


            getContext() {
                document.title = "Parts Picker: " + this.type + " > " + this.brand + " > " + this.model

                if(this.startPosition){
                    let facetLength = this.facets.length
                    if(facetLength > 7) {
                        if (this.startPosition > 10) {
                            this.startPosition = this.startPosition - 2
                        } else {
                            this.startPosition = 0
                        }
                    }
                }
                return {
                    showResults: true,
                    isEmptyList: false,
                    showItems: true,
                    facets: this.facets,
                    model: this.model,
                    brand: this.brand,
                    image: this.image,
                    type: this.type,
                    startPosition: (this.startPosition) ? this.startPosition : 0
                }
            }
        });
    });
